import React from 'react'
import { hydrate } from 'react-dom'

import BootstrapedApp from './bootstrap'

hydrate(<BootstrapedApp />, document.getElementById('root'))
